module.exports = __webpack_public_path__ + "static/media/ic_error_v2.7e941b45.svg";